"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClinicianCalendarTimeZoneText = exports.getCalendarName = exports.calendarEventToAppointmentData = exports.ColorForCalendarGroup = exports.CalendarGroup = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _ColorForCalendarGrou;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CalendarGroup = {
  CalendarEvents: 'calendar-events',
  MonumentAppointments: 'monument-appointments',
  BlockingEvents: 'blocking-events',
  RecurringAvailability: 'recurring-availability',
  DateBasedAvailability: 'date-based-availability',
  UnavailablePeriods: 'unavailable-periods'
};
exports.CalendarGroup = CalendarGroup;
var ColorForCalendarGroup = (_ColorForCalendarGrou = {}, _defineProperty(_ColorForCalendarGrou, CalendarGroup.MonumentAppointments, _utils.TailwindTheme.colors.green2[55]), _defineProperty(_ColorForCalendarGrou, CalendarGroup.BlockingEvents, _utils.TailwindTheme.colors.grey[40]), _defineProperty(_ColorForCalendarGrou, CalendarGroup.RecurringAvailability, _utils.TailwindTheme.colors.orange1[20]), _defineProperty(_ColorForCalendarGrou, CalendarGroup.DateBasedAvailability, _utils.TailwindTheme.colors.blue1[60]), _ColorForCalendarGrou);

// Still using explicit tz here as edge case, since there
// does not seem to be better way to get those time zone names below
exports.ColorForCalendarGroup = ColorForCalendarGroup;
var getClinicianCalendarTimeZoneText = function getClinicianCalendarTimeZoneText(tzName) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _momentTimezone.default)();
  // Can't just use a default parameter value for tzName since it can be null
  if (!tzName) {
    tzName = _momentTimezone.default.tz.guess();
  }
  var tzAbbr = _momentTimezone.default.tz.zone(tzName).abbr(date);
  var tzHuman = (0, _lodash.startCase)((0, _lodash.last)(tzName.split('/')));
  return "".concat(tzAbbr, " (").concat(tzHuman, ")");
};
exports.getClinicianCalendarTimeZoneText = getClinicianCalendarTimeZoneText;
var getCalendarName = function getCalendarName(calendar, clinician) {
  return (0, _utils.hasApplicationCalendar)(clinician.cronofySub) ? 'Monument Calendar' : calendar.calendarName;
};
exports.getCalendarName = getCalendarName;
var calendarEventToAppointmentData = function calendarEventToAppointmentData(eventInfo) {
  var extendedProps = eventInfo.event.extendedProps;
  var patient = extendedProps.patient;
  return {
    patient: patient,
    extendedProps: extendedProps
  };
};
exports.calendarEventToAppointmentData = calendarEventToAppointmentData;